import { dataModels } from '../api/axios';
import { controlData, speed, temperature, getClimate, model1Km, model2Km } from '../helpers/helpers';

const observerOptions = {
  attributes: true,
  childList: true,
  subtree: true
};

const observer = new MutationObserver(() => {
  const wheelCheck = document.querySelector('#wheels[active]');
  const activeWheelSize = wheelCheck.getAttribute('size');
  let acInfo = getClimate.getAttribute('ac');
  acInfo == 'off' ? acInfo = 'down' : acInfo = 'up';
  
  const resultsModel1 = () => {
      console.log(dataModels.length);
      
      let match = false;
      for (let i = 0; i < dataModels[0].length; i++) {
          for (let j = 0; j < dataModels[0][i].hwy.length; j++) {
              if (dataModels[0][i].hwy[j].kmh == speed.value &&
                  dataModels[0][i].temp == temperature.value &&
                  dataModels[0][i].wheelsize == activeWheelSize &&
                  dataModels[0][i].windows == acInfo &&
                  dataModels[0][i].ac == getClimate.getAttribute('status')) {
                  match = true;
                  return model1Km.textContent = dataModels[0][i].hwy[j].kilometers;
              }
          }
      }

      if (match == false) {
          console.log('No match found for model 100D');
      }
  };

  const resultsModel2 = () => {
      let match = false;
      for (let i = 0; i < dataModels[1].length; i++) {
          for (let j = 0; j < dataModels[1][i].hwy.length; j++) {
              if (dataModels[1][i].hwy[j].kmh == speed.value &&
                  dataModels[1][i].temp == temperature.value &&
                  dataModels[1][i].wheelsize == activeWheelSize &&
                  dataModels[1][i].windows == acInfo &&
                  dataModels[1][i].ac == getClimate.getAttribute('status')) {
                  match = true;
                  return model2Km.textContent = dataModels[1][i].hwy[j].kilometers;
              }
          }
      }

      if (match == false) {
          console.log('No match found for model P100D');
      }
  };
  resultsModel1();
  resultsModel2();
});

observer.observe(controlData, observerOptions);
